<div class="space-y-5">

  <!-- Selector de form + lag warning -->
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div class="flex items-center gap-3">
      <label class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Formulario</label>
      <select [(ngModel)]="selectedFormId" (ngModelChange)="onFormChange()"
        class="px-3 py-1.5 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500">
        @for (f of forms; track f.id) {
          <option [ngValue]="f.id">{{ f.name }}</option>
        }
      </select>
    </div>

    <div class="flex items-center gap-2">
      @if (latestStats) {
        <span class="inline-flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400">
          <svg class="w-3.5 h-3.5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Datos al {{ latestStats.statDate | date:'d MMM y' }} · se actualizan diariamente 02:00 UTC
        </span>
      }
      <button (click)="refreshToday()" [disabled]="refreshing || loading"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
        <svg class="w-3.5 h-3.5" [class.animate-spin]="refreshing" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        {{ refreshing ? 'Actualizando...' : 'Actualizar ahora' }}
      </button>
    </div>
  </div>

  <!-- Filtros de rango -->
  <div class="flex flex-wrap items-center gap-2">
    @for (preset of rangePresets; track preset.value) {
      <button (click)="setRange(preset.value)"
        class="px-3 py-1 text-xs font-medium rounded-full transition-colors"
        [class.bg-brand-500]="rangePreset === preset.value"
        [class.text-white]="rangePreset === preset.value"
        [class.dark:bg-white]="rangePreset === preset.value"
        [class.dark:text-gray-900]="rangePreset === preset.value"
        [class.bg-white]="rangePreset !== preset.value"
        [class.text-gray-600]="rangePreset !== preset.value"
        [class.dark:bg-gray-800]="rangePreset !== preset.value"
        [class.dark:text-gray-300]="rangePreset !== preset.value"
        [class.border]="rangePreset !== preset.value"
        [class.border-gray-200]="rangePreset !== preset.value"
        [class.dark:border-gray-700]="rangePreset !== preset.value"
      >{{ preset.label }}</button>
    }

    @if (rangePreset === 'custom') {
      <div class="flex items-center gap-2 px-2 py-1 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
        <input type="date" [(ngModel)]="customFrom" (ngModelChange)="onCustomRangeChange()"
          (click)="$any($event.target).showPicker?.()"
          (focus)="$any($event.target).showPicker?.()"
          class="text-xs bg-transparent border-none outline-none text-gray-700 dark:text-white dark:[color-scheme:dark] cursor-pointer" />
        <span class="text-xs text-gray-400">→</span>
        <input type="date" [(ngModel)]="customTo" (ngModelChange)="onCustomRangeChange()"
          (click)="$any($event.target).showPicker?.()"
          (focus)="$any($event.target).showPicker?.()"
          class="text-xs bg-transparent border-none outline-none text-gray-700 dark:text-white dark:[color-scheme:dark] cursor-pointer" />
      </div>
    }
  </div>

  @if (loading) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Cargando analítica…</p>
  } @else if (!stats.length) {
    <div class="rounded-2xl border border-dashed border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 p-10 text-center">
      <p class="text-sm font-medium text-gray-700 dark:text-gray-300">Sin datos analíticos todavía</p>
      <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Las estadísticas se generan tras el job nocturno. Espera al día siguiente del primer envío.</p>
    </div>
  } @else {

    <!-- ── KPIs totales del rango ─────────────────────────────────────────── -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
      <div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
        <p class="text-xs text-gray-500 dark:text-gray-400">Vistas</p>
        <p class="text-2xl font-semibold text-gray-900 dark:text-white mt-1">{{ totals.totalViews | number }}</p>
      </div>
      <div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
        <p class="text-xs text-gray-500 dark:text-gray-400">Envíos</p>
        <p class="text-2xl font-semibold text-gray-900 dark:text-white mt-1">{{ totals.totalSubmissions | number }}</p>
      </div>
      <div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
        <p class="text-xs text-gray-500 dark:text-gray-400">Conversión promedio</p>
        <p class="text-2xl font-semibold text-gray-900 dark:text-white mt-1">{{ avgConversion | number:'1.1-1' }}%</p>
      </div>
      <div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
        <p class="text-xs text-gray-500 dark:text-gray-400">Contactos nuevos</p>
        <p class="text-2xl font-semibold text-gray-900 dark:text-white mt-1">{{ totals.totalNewContacts | number }}</p>
      </div>
    </div>

    <!-- ── Curva de conversión ──────────────────────────────────────────────── -->
    <div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div class="flex items-end justify-between mb-3">
        <div>
          <p class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Tasa de conversión diaria</p>
          <p class="text-sm text-gray-700 dark:text-gray-300 mt-1">Pico {{ conversionPath.max | number:'1.1-1' }}%</p>
        </div>
        <div class="text-xs text-gray-400 dark:text-gray-500">Envíos / Vistas × 100</div>
      </div>
      <svg viewBox="0 0 480 120" class="w-full h-32">
        @if (conversionPath.path) {
          <path [attr.d]="conversionPath.path" fill="none" stroke="#3B82F6" stroke-width="2"/>
        }
        <line x1="0" y1="119" x2="480" y2="119" stroke="#E5E7EB" stroke-width="1"/>
      </svg>
    </div>

    <!-- ── Tráfico por canal ─────────────────────────────────────────────── -->
    <div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <p class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-3">Vistas por canal</p>
      <div class="space-y-2">
        @for (row of trafficBreakdown; track row.key) {
          <div>
            <div class="flex items-center justify-between text-xs mb-1">
              <span class="text-gray-700 dark:text-gray-300">{{ row.label }}</span>
              <span class="text-gray-500 dark:text-gray-400">{{ row.value | number }} · {{ row.pct | number:'1.0-1' }}%</span>
            </div>
            <div class="h-1.5 rounded-full bg-gray-100 dark:bg-gray-800 overflow-hidden">
              <div class="h-full bg-brand-500 rounded-full" [style.width.%]="row.pct"></div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- ── Dropoff por campo ─────────────────────────────────────────────── -->
    <div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden">
      <div class="px-5 py-3 border-b border-gray-200 dark:border-gray-800">
        <p class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Dropoff por campo</p>
      </div>
      @if (!dropoffByField.length) {
        <p class="px-5 py-6 text-sm text-gray-500 dark:text-gray-400">Sin dropoffs registrados aún.</p>
      } @else {
        <table class="w-full text-sm">
          <thead>
            <tr class="border-b border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50">
              <th class="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Campo</th>
              <th class="px-4 py-2 text-right text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Vistas</th>
              <th class="px-4 py-2 text-right text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Interacciones</th>
              <th class="px-4 py-2 text-right text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Dropoffs</th>
              <th class="px-4 py-2 text-right text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">% Dropoff</th>
            </tr>
          </thead>
          <tbody>
            @for (row of dropoffByField; track row.fieldId) {
              <tr class="border-b border-gray-100 dark:border-gray-800">
                <td class="px-4 py-2 text-gray-800 dark:text-gray-200">{{ row.fieldLabel }}</td>
                <td class="px-4 py-2 text-right text-gray-600 dark:text-gray-300">{{ row.views | number }}</td>
                <td class="px-4 py-2 text-right text-gray-600 dark:text-gray-300">{{ row.interactions | number }}</td>
                <td class="px-4 py-2 text-right text-gray-600 dark:text-gray-300">{{ row.dropoffs | number }}</td>
                <td class="px-4 py-2 text-right">
                  <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium"
                    [class.bg-error-50]="row.dropoffRatePct >= 30"
                    [class.text-error-700]="row.dropoffRatePct >= 30"
                    [class.dark:bg-error-500\/15]="row.dropoffRatePct >= 30"
                    [class.dark:text-error-400]="row.dropoffRatePct >= 30"
                    [class.bg-warning-50]="row.dropoffRatePct >= 15 && row.dropoffRatePct < 30"
                    [class.text-warning-700]="row.dropoffRatePct >= 15 && row.dropoffRatePct < 30"
                    [class.dark:bg-warning-500\/15]="row.dropoffRatePct >= 15 && row.dropoffRatePct < 30"
                    [class.dark:text-warning-400]="row.dropoffRatePct >= 15 && row.dropoffRatePct < 30"
                    [class.bg-success-50]="row.dropoffRatePct < 15"
                    [class.text-success-700]="row.dropoffRatePct < 15"
                    [class.dark:bg-success-500\/15]="row.dropoffRatePct < 15"
                    [class.dark:text-success-400]="row.dropoffRatePct < 15"
                  >{{ row.dropoffRatePct | number:'1.1-1' }}%</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }
</div>
